import zhCN from './zh-CN'
import enUS from './en-US'
import jaJP from './ja-JP'

// 导出所有语言包
export const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ja-JP': jaJP,
}

// 支持的语言列表
export const supportedLocales = [
  { code: 'zh-CN', name: '简体中文', shortName: '中文' },
  { code: 'en-US', name: 'English', shortName: 'EN' },
  { code: 'ja-JP', name: '日本語', shortName: '日' },
]

// 默认语言
export const defaultLocale = 'zh-CN'
